import DatePicker from './DatePicker.component';

export default DatePicker;
